// extracted by mini-css-extract-plugin
module.exports = {"rippleParent":"LightInk_rippleParent__zj-lH","rippleSpan":"LightInk_rippleSpan__1sZEW","ripple":"LightInk_ripple__2ypWi","dummy":"LightInk_dummy__1A-O9"};